import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { saDataAccessibilityPer5QiChartConfig } from '../chartConfigs';

interface DataAccessibilityPer5QiSaEchartsProps {
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const DataAccessibilityPer5QiSaEcharts: React.FC<DataAccessibilityPer5QiSaEchartsProps> = ({ onFullscreenToggle, isFullscreen }) => (
  <SiteCharts config={saDataAccessibilityPer5QiChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} />
);

export default DataAccessibilityPer5QiSaEcharts;
